// extracted by mini-css-extract-plugin
export default {"image":"JW-z","loaded":"KW-z"};